import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { ConsultaConsumidorRequest, Types } from './types';

// ACTIONS
import {
	consultaConsumidorSuccess,
	consultaConsumidorFailure,
} from './actions';

function* consultaConsumidorRequest(request: ReducerAction) {
	const { payload }: { payload: ConsultaConsumidorRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`consumidores/${CHANNEL}/consumidor`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultaConsumidorSuccess(response));
	} else {
		yield put(consultaConsumidorFailure(response));
	}
}

export default all([
	takeLatest(Types.CONSULTA_CONSUMIDOR_REQUEST, consultaConsumidorRequest),
]);
